import React, { useState } from "react";

import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Collapse from "@mui/material/Collapse";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./ExpandableTableRow.module.css";

interface TableRowProps {
  label: string;
  expandableContent: React.ReactNode;
}

const ExpandableTableRow: React.FC<TableRowProps> = ({
  label,
  expandableContent,
}): React.ReactElement => {
  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <div
      className={toClassName(styles.container, {
        [styles.expanded]: expanded,
      })}
    >
      <div className={styles.innerContainer}>
        <div className={styles.flex}>
          {expandableContent && (
            <ArrowRightIcon
              className={toClassName(styles.arrow, {
                [styles.arrowRotateDown]: expanded,
                [styles.arrowRotateRight]: !expanded,
              })}
              onClick={() => setExpanded(!expanded)}
            />
          )}

          <Text variant="title3">{label}</Text>
        </div>
      </div>

      {expandableContent && (
        <Collapse orientation="vertical" in={expanded} collapsedSize={0}>
          <Text variant="body" color="textSubtle">
            {expandableContent}
          </Text>
        </Collapse>
      )}
    </div>
  );
};

export default ExpandableTableRow;
